import React , {useState} from 'react';
import icon1 from '../assets/images/svg/icon-create-5.svg'
import icon2 from '../assets/images/svg/icon-create-6.svg'
import icon3 from '../assets/images/svg/icon-create-3.svg'
import icon4 from '../assets/images/svg/icon-create-7.svg'
import icon5 from '../assets/images/svg/icon-create-8.svg'
import icon6 from '../assets/images/svg/icon-create-9.svg'
import { Link } from 'react-router-dom';


function HelpCenter(props) {
    const [dataHelp] = useState([
        {
            id: 1,
            icon: icon1,
            title: 'Getting Started',
            text: 'Learn how to create your account, browse vouchers, and start building your digital vault on D.T Wallet',
            link: '/faqs'
        },
        {
            id: 2,
            icon: icon2,
            title: 'Buying Vouchers',
            text: 'Discover how to purchase vouchers from top brands, add them to cart, and complete secure checkout',
            link: '/explore'
        },
        {
            id: 3,
            icon: icon3,
            title: 'My Vault',
            text: 'Learn how to access, organize, and manage your stored vouchers in your personal digital vault',
            link: '/dashboard'
        },
        {
            id: 4,
            icon: icon4,
            title: 'Redeeming Vouchers',
            text: 'Step-by-step guide on how to redeem your vouchers at partner stores and online platforms',
            link: '/faqs'
        },
        {
            id: 5,
            icon: icon5,
            title: 'Payment & Security',
            text: 'Understand our secure payment methods, refund policies, and how we protect your transactions',
            link: '/policies'
        },
        {
            id: 6,
            icon: icon6,
            title: 'Account & Support',
            text: 'Get help with account settings, password recovery, and reach our 24/7 customer support team',
            link: '/contact'
        },
    ])
    return (
        <div>
            <section className="tf-page-title style-2">    
                <div className="tf-container">
                    <div className="row">
                        <div className="col-md-12">

                            <ul className="breadcrumbs">
                                <li><Link to="/">Home</Link></li>
                                <li><Link to="#">Pages</Link></li>
                                <li>Help Center</li>
                            </ul>
                   
                        </div>
                    </div>
                </div>                    
            </section>
                
            <section className="tf-help-center">
                <div className="tf-container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8 col-md-12">
                            <div className="tf-heading style-5">
                                <h4 className="heading">How Can We Help You?</h4>
                                <p className="sub-heading">Find answers to common questions about buying, storing, and redeeming vouchers on D.T Wallet. Our support team is here to help you 24/7.</p>
                            </div>

                            <form action="#" className="help-center-form">
                                <input type="text" placeholder="Search for help topics..." required="" />
                                <button><i className="fas fa-search"></i></button>
                            </form>

                            <h4 className="heading-help">Popular Help Topics</h4>

                            <div className="tf-create-wrap">

                                {
                                    dataHelp.map(idx => (
                                        <div key={idx.id} className="tf-create style-2">
                                            <div 
                                                className="icon"
                                                style={{
                                                    background: '#FFC107',
                                                    borderRadius: '50%',
                                                    width: '80px',
                                                    height: '80px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    margin: '0 auto 20px'
                                                }}
                                            >
                                                <img 
                                                    src={idx.icon} 
                                                    alt="Binasea"
                                                    style={{
                                                        filter: 'brightness(0)',
                                                        width: '40px',
                                                        height: '40px'
                                                    }}
                                                />
                                            </div>
                                            <h6 className="title"><Link to="#"> {idx.title}</Link></h6>
                                            <p className="content">{idx.text}</p>
                                            <div className="button">
                                                <Link to={idx.link} className="tf-button">View more<i className="fal fa-long-arrow-right"></i></Link>
                                            </div>
                                        </div>
                                    ))
                                }
                            
                               
        
                            </div>
                            
                        </div>
                    </div>
                </div>
            </section>
            
        </div>
    );
}

export default HelpCenter;